import {app} from "@/modules/app";
import {useStackRouteComponent} from "@/packages/stack-router/hooks/useStackRoute";

app.addRoutes([
    {
        parent: 'public',
        path: '/notice/show/:id',
        component: useStackRouteComponent(() => import("@/pages/notice/notice.dialog.vue")),
        meta: {}
    },
    {
        parent: 'personal',
        path: '/personal/notices',
        component: useStackRouteComponent(() => import("@/pages/notice/notices.dialog.vue")),
        meta: {}
    },
])

